<template>
  <BaseCardList
      :item-list="itemList"
      :common="common"
      :delete-restore-event="onValidate"
      :default-item="newItem"
      :correct-default-item="function() {return true}"
      :enable-add-row="function() {return true}"
      xl="12" lg="12" md="12" sm="12" xs="12"
      :system-bar-height="24"
      :get-card-title-color="getTitleColor"
      :disableDrag="false"
      :disable-item-edit="function(x){return readonly}"
      :show-deleted="showDeleted"
      :new-item-name="$t('new_parameter')"
  >
    <template v-slot:body="params">
      <v-sheet class="px-0 pt-2 pb-1">
        <v-row class="flex-nowrap">
          <BaseAttributeTemplate :item="params.item" :readonly="readonly"></BaseAttributeTemplate>
        </v-row>
      </v-sheet>
    </template>
  </BaseCardList>
</template>

<script>
import BaseCardList from "@/components/Base/BaseCardList";
import BaseAttributeTemplate from "@/components/Base/BaseAttributeTemplate";


export default {
  name: 'SubtaskAttributeCardList',
  props: {
    height: {type: [Number], default: window.innerHeight},
    systemBarHeight: {type: [Number], default: 36},
    itemList: {factory: []},
    readonly: {type: [Boolean], default: false},
    common: {type: [Object], factory: {}},
    showDeleted: {type: [Boolean], default: true},
    tabs: {type: [Function], default: function (item) {return []}},
    defaultTab: {type: [Number], default: 0},
    defaultTabAfterAdd: {type: [Number], default: 0},
  },

  components: {
    BaseCardList,
    BaseAttributeTemplate,
  },

  computed: {},

  watch: {
    itemList: {
      handler(newValue, oldValue) {
        // console.log('watch')
        this.emitValue()
      },
      deep: true
    }
  },

  methods: {
    lockPage(editedItem) {
      return !(!!editedItem && !!editedItem.page_properties && !editedItem.page_properties.lock_page)
    },

    emitValue() {
      // console.log('emitValue')
      this.$emit('update:itemList', this.itemList)
    },

    tabsList(item) {
      let name = this.$t('new_task')
      let group = this.$t('type')
      if (!!item.name)
        name = item.name
      if (!!item.task_type)
        group = item.task_type.group
      let tabs = [group, name]
      if (!!item && !!item.subtasks)
        item.subtasks.forEach(row => tabs.push(row.name))
      return tabs
    },

    onValidate() {

    },
    getTitleColor({item, index}) {
      return 'grey lighten-2'
    },
  },

  async mounted() {
  }
  ,

  data() {
    return {
      newItem: {
        name: null,
        deleted: false,
        category: 'text',
      },
    }
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "new_parameter": "New parameter"
  },
  "de": {
    "new_parameter": "Neuer Parameter"
  }
}
</i18n>
